import { render, staticRenderFns } from "./Propriedades.vue?vue&type=template&id=7eadb44e"
import script from "./Propriedades.vue?vue&type=script&lang=js"
export * from "./Propriedades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports